import { createJsonApiHooks } from "./useJSON";

export const {
  useAll: useReunions,
  useOne: useReunion,
  useAdd: useAddReunion,
  useUpdate: useUpdateReunion,
  useDelete: useDeleteReunion
} = createJsonApiHooks("reunions");